export enum ReeferEngineModeCategory {
    Unknown = -1,
    Diesel = 0,
    Electric = 1
}
